import get from 'lodash/get';
import moment from 'moment-timezone';

import reduceDatasetsByViewblockState from '../../../utils/reduceDatasetsByViewblockState';
import { CfJsonVariables, MandateProps, StateTime } from '../../types';
import { HarbourDialModel, HarbourDialState } from '../types';
import getObsData from './getObsData';

type RequiredHarbourDialState = MandateProps<HarbourDialState, 'datasets' | 'viewblockState' | 'currentTime'>;

const OUTDATED_THRESHOLD = 120; // in seconds

const getLatestIndex = (variables: CfJsonVariables) => {
    try {
        const latest = [...variables.time.data].sort((a, b) => new Date(b).valueOf() - new Date(a).valueOf())[0];

        return variables.time.data.indexOf(latest);
    } catch (e) {
        console.error(e);
        console.error(variables);
        return -1;
    }
};

const mergeTemplateAndData = ({ datasets, viewblockState, currentTime, model }: RequiredHarbourDialState): HarbourDialModel | undefined => {
    const filteredDatasets = reduceDatasetsByViewblockState({ datasets, viewblockState });
    const variablesList = filteredDatasets
        .map((filteredDataset) => filteredDataset.cfjson?.variables)
        .filter((variables): variables is CfJsonVariables => !!variables);
    const firstVariables = filteredDatasets?.[0]?.cfjson?.variables;
    if (!firstVariables) {
        return undefined;
    }
    const latestIndex = getLatestIndex(firstVariables);
    const obsData = getObsData({ variablesList, latestIndex });
    const latestTimestamp = (get(firstVariables, `time.data[${latestIndex}]`) || get(model, 'obsTime.iso8601')) as unknown as string;

    let obsTime: StateTime | undefined;
    let isOutdated = true;

    if (latestTimestamp) {
        const dateTime = moment.utc(latestTimestamp);

        isOutdated = dateTime.unix() < moment(currentTime.iso8601).unix() - OUTDATED_THRESHOLD;
        obsTime = { iso8601: dateTime.toISOString(), timezone: currentTime.timezone };
    }

    return {
        settings: viewblockState.settings,
        obsData,
        obsTime,
        isOutdated,
    };
};

export default mergeTemplateAndData;
export { RequiredHarbourDialState };
